export const numericTypes = {
    integer: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
    },
    decimal: {
        decimal: '.',
        thousands: ' ',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
    },
    decimalNoScale: {
        decimal: '.',
        thousands: ' ',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
    }
};